"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var strings_1 = require("./strings");
exports.ANNOUNCEMENT_ACTIONS = [strings_1.CREATED, strings_1.DELETED, strings_1.UPDATED, strings_1.VIEWED];
